/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/idelta.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Calculates the difference between the last two samples of each time series in a range vector. Operates on gauges: counter inputs are automatically and transparently converted to a gauge with `to_gauge`. The result is always a `double`.
 *
 * @example
 * idelta(cpu_temp_celsius[5m])
 */
const definition: PromqlFunctionDefinition = {
  type: 'within_series',
  name: 'idelta',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'range_vector',
          optional: false,
          description: 'Range vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
